"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmbeddedWorkflow = exports.CreateEmbeddedWorkflow = exports.CreateEmbeddedWorkflowActionTypes = exports.stopImportPolling = exports.startImportPolling = exports.fetchImportDetails = exports.FetchImportDetailsActions = exports.FetchImportDetailsActionTypes = exports.startImport = exports.StartImportActions = exports.StartImportActionTypes = exports.stopStatsPolling = exports.startStatsPolling = exports.loadStats = exports.FetchStatsActions = exports.FetchStatsActionTypes = exports.loadStoreDetails = exports.FetchStoreDetailsActions = exports.FetchStoreDetailsActionTypes = exports.loadStores = exports.FetchStoresActions = exports.FetchStoresActionTypes = exports.EcommerceV2ActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var EcommerceV2ActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_STORES: null,
  FETCH_STORE_DETAILS: null,
  FETCH_STATS: null,
  START_IMPORT: null,
  START_IMPORT_POLLING: null,
  STOP_IMPORT_POLLING: null,
  START_STATS_POLLING: null,
  STOP_STATS_POLLING: null,
  FETCH_IMPORT_DETAILS: null,
  CREATE_EMBEDDED_WORKFLOW: null
}, 'ecommerce-v2');
/* Stores */

exports.EcommerceV2ActionTypes = EcommerceV2ActionTypes;
var FetchStoresActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.FETCH_STORES);
exports.FetchStoresActionTypes = FetchStoresActionTypes;
var FetchStoresActions = (0, _actions.createRequestActions)(FetchStoresActionTypes);
exports.FetchStoresActions = FetchStoresActions;
var loadStores = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.FETCH_STORES);
/* Store details */

exports.loadStores = loadStores;
var FetchStoreDetailsActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.FETCH_STORE_DETAILS);
exports.FetchStoreDetailsActionTypes = FetchStoreDetailsActionTypes;
var FetchStoreDetailsActions = (0, _actions.createRequestActions)(FetchStoreDetailsActionTypes);
exports.FetchStoreDetailsActions = FetchStoreDetailsActions;
var loadStoreDetails = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.FETCH_STORE_DETAILS, function (storeToken) {
  return storeToken;
});
/* stats */

exports.loadStoreDetails = loadStoreDetails;
var FetchStatsActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.FETCH_STATS);
exports.FetchStatsActionTypes = FetchStatsActionTypes;
var FetchStatsActions = (0, _actions.createRequestActions)(FetchStatsActionTypes);
exports.FetchStatsActions = FetchStatsActions;
var loadStats = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.FETCH_STATS, function (storeToken) {
  return storeToken;
});
exports.loadStats = loadStats;
var startStatsPolling = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.START_STATS_POLLING, function (storeToken) {
  return storeToken;
});
exports.startStatsPolling = startStatsPolling;
var stopStatsPolling = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.STOP_STATS_POLLING);
/* import */

exports.stopStatsPolling = stopStatsPolling;
var StartImportActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.START_IMPORT);
exports.StartImportActionTypes = StartImportActionTypes;
var StartImportActions = (0, _actions.createRequestActions)(StartImportActionTypes);
exports.StartImportActions = StartImportActions;
var startImport = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.START_IMPORT, function (storeToken) {
  return storeToken;
});
exports.startImport = startImport;
var FetchImportDetailsActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.FETCH_IMPORT_DETAILS);
exports.FetchImportDetailsActionTypes = FetchImportDetailsActionTypes;
var FetchImportDetailsActions = (0, _actions.createRequestActions)(FetchImportDetailsActionTypes);
exports.FetchImportDetailsActions = FetchImportDetailsActions;
var fetchImportDetails = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.FETCH_IMPORT_DETAILS, function (storeToken) {
  return storeToken;
});
exports.fetchImportDetails = fetchImportDetails;
var startImportPolling = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.START_IMPORT_POLLING, function (storeToken) {
  return storeToken;
});
exports.startImportPolling = startImportPolling;
var stopImportPolling = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.STOP_IMPORT_POLLING);
/* Embedded WF */

exports.stopImportPolling = stopImportPolling;
var CreateEmbeddedWorkflowActionTypes = (0, _actions.createRequestTypes)(EcommerceV2ActionTypes.CREATE_EMBEDDED_WORKFLOW);
exports.CreateEmbeddedWorkflowActionTypes = CreateEmbeddedWorkflowActionTypes;
var CreateEmbeddedWorkflow = (0, _actions.createRequestActions)(CreateEmbeddedWorkflowActionTypes, {
  successPayloadCreator: function successPayloadCreator(response, props) {
    return {
      data: response,
      props: props
    };
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateEmbeddedWorkflow.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('ecommerce.dashboard.automation.createWorkflow.failure')));
  }
});
exports.CreateEmbeddedWorkflow = CreateEmbeddedWorkflow;
var createEmbeddedWorkflow = (0, _fluxActions.createAction)(EcommerceV2ActionTypes.CREATE_EMBEDDED_WORKFLOW, (0, _actions.mapPayloadTo)('data'));
exports.createEmbeddedWorkflow = createEmbeddedWorkflow;